<template>
    <div class="search_box" v-bind:style="{ height: Height + 'px' }">
        <!-- 文献查找 -->
        <el-container class="search_container">
           
            <el-main v-bind:style="{ height: Height + 'px !important' }" style="padding:16px  20px;" :class="keys == '1'?'main_css':''" >
                <Intelligent v-if="keys == '1'"></Intelligent>
                <!-- <RETRIEVAL v-else-if="keys == '2'" @Guide="shows" @tabSub="tabSub_"></RETRIEVAL> -->
                <AnsweringAi  v-else-if="keys == '3'"></AnsweringAi>
                <Management v-else-if="keys == '2'" @getTreeData="testData"></Management>
                <TOOL v-else-if="keys == '4'"></TOOL>
            </el-main>
        </el-container>
    </div>
</template>

<script>
import RETRIEVAL from "./search_component/retrieval.vue";
// import MANAGE from "./search_component/manage.vue";
import Management from "./search_component/management_new.vue";
import TOOL from "./search_component/tool.vue";
import Intelligent from "./search_component/intelligent.vue";
import AnsweringAi from "./search_component/answeringAi.vue";
import { newUnreadNumber } from "@/Api/manage";
import { applet_login } from "@/Api/translation";
import store from "@/store";
export default {
    data() {
        return {
            Height: 0,
            keys: "",
            total: null,
            dialogVisible: false,
            imgs: [
                "../../assets/imgs/青梨PC端引导图/搜索.jpg",
                "../../assets/imgs/青梨PC端引导图/提交.jpg",
                "../../assets/imgs/青梨PC端引导图/筛选.jpg",
                
            ],
            imgSrc: "../../assets/imgs/青梨PC端引导图/搜索.jpg",
            one: false,
            two: false,
            three: false,
            intervalId: null,
            timer: "",
            value: 0,
        };
    },
    mounted() {
        this.updateSearchLayoutHeight();
        this.handleSearchLayoutResize = () => {
            this.updateSearchLayoutHeight();
        };
        window.addEventListener("resize", this.handleSearchLayoutResize);
        if (window.visualViewport) {
            window.visualViewport.addEventListener(
                "resize",
                this.handleSearchLayoutResize
            );
        }
    },

    created() {
        console.log(store.getCookie("token"));
        if (this.$route.params.one == "yes") {
            this.dialogVisible = true;
            // this.imgSrc = this.imgs[0];
            this.one = true;
        }
        if (this.$route.query.webPage) {
            this.keys = this.$route.query.webPage.toString();
        }
        this.loginAutomatic();
    },
    // 监听路由变化
    watch: {
        $route(to, from) {
            if (to.query.webPage) {
                this.keys = to.query.webPage.toString();
            }
        },
    },
    methods: {
        updateSearchLayoutHeight() {
            this.Height = document.documentElement.clientHeight - 80;
        },
        tabSub_(val) {
            console.log('a')
            this.keys = 1;
            this.$router.push({
                name: "Search",
                query: { webPage: 1 },
            });
        },
        testData(da) {
            // console.log("parent");
            // console.log(da)
            if (da == 0) {
                this.total = "";
            } else {
                this.total = da;
            }
        },
        next(index) {
            // console.log(index)
            if (index == "1") {
                this.one = false;
                this.two = true;
            }
            if (index == "2") {
                this.two = false;
                this.three = true;
            }
            if (index == "3") {
                this.three = false;
                this.dialogVisible = false;
            }
        },
        shows(sh) {
            this.dialogVisible = true;
            this.one = true;
        },
        loginAutomatic() {
      var tmp = Date.parse(new Date()).toString();
      tmp = tmp.substr(0, 10);

      let event = localStorage.getItem("code") + "|" + tmp;
      // console.log(event);
      let codesid = {
        code: event,
      };

    //   applet_login(codesid)
    //     .then((res) => {
    //       // 提交成功 弹出提示框并刷新页面
    //       console.log(res);
    //       if (res.data.status == 1) {
    //       } else {
    //         if (
    //           res.data.data &&
    //           res.data.data.token &&
    //           res.data.data.token.token
    //         ) {
    //           localStorage.setItem("token_USID", res.data.data.token.token);
    //         }
    //       }
    //       if (res.status == 200) {
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    },
    },
    components: {
        RETRIEVAL,
        // MANAGE,
        Management,
        TOOL,
        Intelligent,
        AnsweringAi
    },
    destroyed() {
        if (this.handleSearchLayoutResize) {
            window.removeEventListener("resize", this.handleSearchLayoutResize);
            if (window.visualViewport) {
                window.visualViewport.removeEventListener(
                    "resize",
                    this.handleSearchLayoutResize
                );
            }
        }
    },
};
</script>

<style lang="less" scoped>
.main_css{
    // background: #f9f0f4 !important;
    background: #fff !important;
    padding:  20px 0 !important;
}
.search_box {
    box-sizing: border-box;
    height: 100%;

    .search_container {
        height: 100%;
    }

    .el-aside {
        background-color: #fff;
        color: #333;
        text-align: center;
        line-height: 200px;
    }

    ::v-deep .el-main {
        min-width: 1130px;
        height: 100%;
        // background-color: #e9eef3;
        background-color: #f5f5f5;
        color: #333;
    }

    body>.el-container {
        margin-bottom: 40px;
    }

    .el-container:nth-child(5) .el-aside,
    .el-container:nth-child(6) .el-aside {
        line-height: 260px;
    }

    .el-container:nth-child(7) .el-aside {
        line-height: 320px;
    }

    .el-menu {
        background-color: #fff;
    }
}

.is-active div {
    background-color: #e2426b;
    border-radius: 5px;

    span {
        color: #fff;
    }

    i {
        color: #fff;
    }
}

.el-menu-item {
    padding: 5px 50px !important;
    background-color: #fff;
}

.aside_item {
    width: 100%;
    height: 50px;
    line-height: 50px;

    span {
        color: #b1aec8;
        font-size: 15px;
    }
}

.item {
    line-height: 30px;

    /deep/ .el-badge__content.is-fixed {
        position: absolute;
        top: 0px;
        right: 13px;
        transform: translateY(-50%) translateX(100%);
    }
}

.popContainer {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    background: rgba(0, 0, 0, 0.5);

    img {
        z-index: 99;
    }

    .el-button {
        z-index: 100;
        position: absolute;
        top: 200px;
        right: 300px;
        background: rgb(79, 176, 255);
        border: none;
    }
}
</style>

<style>
.dialogOne {
    background-color: none !important;
}

/*标题背景色*/
.dialogOne .el-dialog__header {
    background-color: none !important;
    display: none !important;
}

/*body背景色*/
.dialogOne .el-dialog__body {
    background-color: none !important;
    height: 80vh;
}
</style>